import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import "../Style/VendorFilter.css";

const DatalistInput = ({
  label,
  name,
  value,
  listId,
  options,
  onChange,
  displayKey = "label",
  showList,
  inputRef,
  onKeyDown,
}) => {
  return (
    <Form.Group as={Col} xs={6} sm={4} md={3} lg={2} controlId={name}>
      <div className="dropdown-label">{label}</div>
      <Form.Control
        type="text"
        list={showList ? listId : undefined}
        value={value}
        placeholder={` ${label}`}
        onChange={(e) => onChange(name, e.target.value)}
        onKeyDown={onKeyDown}
        autoComplete="off"
        ref={inputRef}
      />
      {showList && (
        <datalist id={listId}>
          {options.map((opt, index) => (
            <option key={index} value={opt[displayKey]}>
              {opt.label}
            </option>
          ))}
        </datalist>
      )}
    </Form.Group>
  );
};

const TripFilter = ({
  filters,
  onFilterChange,
  vendors,
  vehicles,
  onFind,
  loading,
  onReset,
}) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [showDropdown, setShowDropdown] = useState({
    vendor_id: false,
    vehicle_id: false,
    // status: false,
  });

  const vendorRef = useRef(null);
  const vehicleRef = useRef(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  // const statusRef = useRef(null);
  const findBtnRef = useRef(null);
  const resetBtnRef = useRef(null);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleInputChange = (name, value) => {
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
    onFilterChange(name, value);

    setShowDropdown((prev) => ({
      ...prev,
      [name]: String(value || "").trim().length > 0,
    }));
  };

  const handleVendorChange = (name, value) => {
    const vendor = vendors.find(
      (v) => v.name.toLowerCase() === value.toLowerCase(),
    );
    handleInputChange("vendor_id", vendor ? vendor.id : value);
  };

  const handleVehicleChange = (name, value) => {
    const vehicle = vehicles.find(
      (ve) => ve.vehicle_number.toLowerCase() === value.toLowerCase(),
    );
    handleInputChange("vehicle_id", vehicle ? vehicle.id : value);
  };

  const handleKeyDown = (e, nextRef, action) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (typeof action === "function") {
        action();
      }
      nextRef?.current?.focus();
    }
  };

  return (
    <Form className="vendor-advance-filter-form">
      <Row>
        {/* Vendor */}
        <DatalistInput
          label="Vendor"
          name="vendor_id"
          value={
            vendors.find((v) => v.id === localFilters.vendor_id)?.name ||
            localFilters.vendor_id
          }
          listId="vendorList"
          options={vendors.map((v) => ({ value: v.id, label: v.name }))}
          onChange={handleVendorChange}
          showList={showDropdown.vendor_id}
          inputRef={vendorRef}
          onKeyDown={(e) => handleKeyDown(e, vehicleRef)}
        />

        {/* Vehicle */}
        <DatalistInput
          label="Vehicle"
          name="vehicle_id"
          value={
            vehicles.find((ve) => ve.id === localFilters.vehicle_id)
              ?.vehicle_number || localFilters.vehicle_id
          }
          listId="vehicleList"
          options={vehicles.map((ve) => ({
            value: ve.id,
            label: ve.vehicle_number,
          }))}
          onChange={handleVehicleChange}
          showList={showDropdown.vehicle_id}
          inputRef={vehicleRef}
          onKeyDown={(e) => handleKeyDown(e, fromDateRef)}
        />
        <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
          <div className="dropdown-label">From Date</div>
          <Form.Control
            type="date"
            value={localFilters.from_date}
            ref={fromDateRef}
            onChange={(e) => handleInputChange("from_date", e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, toDateRef)}
          />
        </Form.Group>

        {/* To Date */}
        <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
          <div className="dropdown-label">To Date</div>
          <Form.Control
            type="date"
            value={localFilters.to_date}
            ref={toDateRef}
            onChange={(e) => handleInputChange("to_date", e.target.value)}
            // onKeyDown={(e) => handleKeyDown(e, statusRef)}
          />
        </Form.Group>

        {/* Buttons */}
        <Col className="d-flex justify-content-end align-items-center">
          <Button
            variant="primary"
            className="me-2"
            onClick={onFind}
            disabled={loading}
            ref={findBtnRef}
            onKeyDown={(e) => handleKeyDown(e, resetBtnRef, onFind)}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Finding...
              </>
            ) : (
              "Find"
            )}
          </Button>
          <Button
            variant="secondary"
            onClick={onReset}
            ref={resetBtnRef}
            onKeyDown={(e) => handleKeyDown(e, null, onReset)}
          >
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default TripFilter;
